module.exports = __webpack_public_path__ + "img/SeidViroj-MewlanZade.683048a3.jpg";